export const DOCUMENT_SITE_ORIGIN = {
    GLOBAL : 'Global',
    JAPAN:'Japan'
}
export const SITE_PROCESSING_DOCUMENT = [{label:"Global",value:"Global"},{label:"Japan",value:"Japan"}]
export const STATUS = {
    "NEW":600000,
    "DUPLICATE":600001,
    "NOT_ORDERED":600002,
    "ORDER_NON_VALID":600003,
    "ORDER_VALID":600004,
    "VALID_NON_ENTRY":600005,
    "VALID":600006,
    "NON_VALID":600007,
    "ARTICLE_NOT_RETRIEVABLE":600008,
    "ARTICLE_ORDERED_NON_VALID":600009,
    "ARTICLE_ORDERED_VALID":600010,
    "OTHER":600011,
    "TRANSLATION_REQUESTED":600012,
    "VALID_SAVE_AS":600013,
    "PENDING":600014,
    "REVIEW_NEEDED":600015,
    "QUALITY_REVIEW":600017,
    "JP_RESEARCH":600018,
    "MAILING_NEEDED":600019,
    "SUBMISSIONS_NEEDED":600020,
    "EUDRAVIGILANCE":600021,
    "LINKED":600022,
    "JP_RESEARCH_ORDER":600023,
    "JP_DEVICE_ORDER_VALID":600024,
    "JP_DEVICE_ORDER_NON_VALID":600025,
    "ARTICLE_ORDERED_JP_RESEARCH":600026,
    "NO_JP_RESEARCH":600027
}